<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    :max-width="dialogWidth"
    scrollable
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t('app.buttons.edit') }} {{ $t('app.sucursales.single') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            rounded
            color="primary"
            @click="saveItem"
          >
            {{ $t('app.buttons.save') }}
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <validation-observer
          ref="observer"
          v-slot="{ validate, reset }"
        >
          <form>
            <v-list
              three-line
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.name') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.name')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="item.nombre"
                        :placeholder="$t('app.headers.name')"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.code') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.code')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="item.code"
                        :placeholder="$t('app.headers.code')"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.street') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.street')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="item.calle"
                        :placeholder="$t('app.headers.street')"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.suburb') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.suburb')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="item.colonia"
                        :placeholder="$t('app.headers.suburb')"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.state') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.state')"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="item.estado_id"
                        :placeholder="$t('app.headers.state')"
                        :items="estados"
                        item-text="nombre"
                        item-value="id"
                        :error-messages="errors"
                        required
                        @change="getMunicipiosByState"
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.municipality') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.municipality')"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="item.municipio_id"
                        :placeholder="$t('app.headers.municipality')"
                        :items="municipios"
                        item-text="nombre"
                        item-value="id"
                        :disabled="!municipios"
                        :error-messages="errors"
                        required
                        @change="getLocalidadesByMunicipality"
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('app.headers.location') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('app.headers.description')"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="item.localidad_id"
                        :placeholder="$t('app.headers.location')"
                        :items="localidades"
                        item-text="nombre"
                        item-value="id"
                        :disabled="!localidades"
                        :error-messages="errors"
                        required
                      />
                    </validation-provider>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'SucursalesAdd',
    data () {
      return {
        dialog: false,
        item: {
          nombre: '',
          calle: '',
          colonia: '',
          estado_id: 0,
          municipio_id: 0,
          localidad_id: 0,
        },
        estados: [],
        municipios: [],
        localidades: [],
      }
    },
    mounted () {
      EventBus.$on('sucursales-edit', async (item) => {
        this.toggleLoader()
        this.item = item
        this.estados = await this.getStates()
        this.toggleLoader()

        await this.getMunicipiosByState()
        await this.getLocalidadesByMunicipality()

        this.dialog = true
      })
    },
    methods: {
      async getMunicipiosByState () {
        this.toggleLoader()
        this.municipios = await this.getMunicipalityByEstado(this.item.estado_id)
        this.toggleLoader()
      },
      async getLocalidadesByMunicipality () {
        this.toggleLoader()
        this.localidades = await this.getLocationsByMunicipality(this.item.municipio_id)
        this.toggleLoader()
      },
      async saveItem () {
        this.$refs.observer.validate()
          .then(async success => {
            if (!success) return

            this.toggleLoader()

            await this.$http.post(route('v1/branch/' + this.item.id), this.item)
              .then(response => {
                if (response.body.code === 200) {
                  this.processSuccess(response)
                  this.dialog = false
                  EventBus.$emit('reload-items')
                } else {
                  this.processError(response)
                }
              }, error => {
                this.processError(error)
              })

            this.toggleLoader()
          })
      },
    },
  }
</script>

<style scoped>

</style>
